<div class="page-container">
  <div class="campanha">
    <div>
      <form [formGroup]="searchFormCpf" (submit)="buscarClientePorCpf()">
        <div class="d-flex align-items-center">
          <div class="col-7 pr-0">
            <mat-form-field class="w-100">
              <mat-label>CPF</mat-label>
              <input formControlName="cpf" [mask]="'000.000.000-00'" matInput />
            </mat-form-field>
          </div>
          <div class="col-5 pl-0">
            <button *ngIf="!cliente" type="submit" [ngClass]="'btn-action-' + user.empresa?.cor_lowercase.toLowerCase()"
              class="btn btn-azul btn-block mb-3">
              Buscar
            </button>
            <button *ngIf="cliente" (click)="
                cliente = null;
                searchFormCpf.reset();
                searchFormCnpj.reset();
                searchFormTelefone.reset()
              " type="clear" class="btn btn-rosa btn-block mb-3">
              Limpar
            </button>
          </div>
        </div>
      </form>
    </div>
    <div>
      <form [formGroup]="searchFormCnpj" (submit)="buscarClientePorCnpj()">
        <div class="d-flex align-items-center">
          <div class="col-7 pr-0">
            <mat-form-field class="w-100">
              <mat-label>CNPJ</mat-label>
              <input formControlName="cnpj" [mask]="'00.000.000/0000-00'" matInput />
            </mat-form-field>
          </div>
          <div class="col-5 pl-0">
            <button *ngIf="!cliente" type="submit" [ngClass]="'btn-action-' + user.empresa?.cor_lowercase.toLowerCase()"
              class="btn btn-azul btn-block mb-3">
              Buscar
            </button>
            <button *ngIf="cliente" (click)="
                cliente = null;
                searchFormCpf.reset();
                searchFormCnpj.reset();
                searchFormTelefone.reset()
              " type="clear" class="btn btn-rosa btn-block mb-3">
              Limpar
            </button>
          </div>
        </div>
      </form>
    </div>
    <div>
      <form [formGroup]="searchFormTelefone" (submit)="buscarClientePorTelefone()">
        <div class="d-flex align-items-center">
          <div class="col-7 pr-0">
            <mat-form-field class="w-100">
              <mat-label>Telefone</mat-label>
              <input formControlName="telefone" [mask]="telefoneMask" matInput />
            </mat-form-field>
          </div>
          <div class="col-5 pl-0">
            <button *ngIf="!cliente" type="submit" [ngClass]="'btn-action-' + user.empresa?.cor_lowercase.toLowerCase()"
              class="btn btn-azul btn-block mb-3">
              Buscar
            </button>
            <button *ngIf="cliente" (click)="
                cliente = null;
                searchFormCpf.reset();
                searchFormCnpj.reset();
                searchFormTelefone.reset()
              " type="clear" class="btn btn-rosa btn-block mb-3">
              Limpar
            </button>
          </div>
        </div>
        <div *ngIf="error" class="alert alert-danger">
          {{ error }}
        </div>
      </form>
    </div>

    <div class="clientes-list">
      <mat-list>
        <mat-list-item (click)="cliente = clienteList"
          [ngClass]="cliente?.cpf == clienteList?.cpf ? 'alert-success' : ''" *ngFor="let clienteList of clientes">
          <small matLine class="text-uppercase text-black-50">
            {{ clienteList?.nome }}
          </small>
          <h5 matLine class="font-weight-bold text-cinza">
            {{ clienteList?.cpf | mask : "000.000.000-00" }}
          </h5>
          <button mat-icon-button>
            <mat-icon class="mat-24">visibility</mat-icon>
          </button>
        </mat-list-item>
      </mat-list>
    </div>

    <hr />

    <app-ativacao-actions [modoCampanha]="false" *ngIf="cliente" [cliente]="cliente" [ativacao]="ativacao"
      [currentVendedorInfo]="this.vendedorInfo" (finalizouAtivacao)="resetPage($event)"></app-ativacao-actions>
  </div>
</div>